export default {
  namespaced: true,
  state: {
    orderInvoiceModal: {
      isOpen: false,
      orderId: null,
    },
    confirmationModal: {
      isOpen: false,
      title: "Confirmation",
      message: "Are you sure you want to perform that action?",
      item: "",
      callback: null,
    },
    // settingsModal: {
    //   isOpen: false,
    // },
  },
  mutations: {
    SET_ORDER_INVOICE_MODAL_STATE(state, { isOpen, orderId = null }) {
      state.orderInvoiceModal.isOpen = isOpen;
      state.orderInvoiceModal.orderId = orderId;
      if (orderId) {
        this.dispatch("order/fetchOrder", orderId);
      }
    },
    SET_CONFIRMATION_MODAL_STATE(
      state,
      {
        isOpen,
        title = "Confirmation",
        message = "Are you sure you want to perform that action?",
        item = "",
        callback = null,
      }
    ) {
      state.confirmationModal.isOpen = isOpen;
      state.confirmationModal.title = title;
      state.confirmationModal.message = message;
      state.confirmationModal.item = item;
      state.confirmationModal.callback = callback;
    },
    // SET_SETTINGS_MODAL_STATE(state, { isOpen }) {
    //   state.settingsModal.isOpen = isOpen;
    // },
  },
  actions: {
    openOrderInvoiceModal({ commit }, orderId) {
      // await dispatch("order/getOrderItems", orderId, { root: true });
      commit("SET_ORDER_INVOICE_MODAL_STATE", { isOpen: true, orderId });
    },
    closeOrderInvoiceModal({ commit }) {
      // await dispatch("order/clearOrderItems", { root: true });
      commit("SET_ORDER_INVOICE_MODAL_STATE", { isOpen: false });
    },
    openConfirmationModal({ commit }, { title, message, item, callback }) {
      commit("SET_CONFIRMATION_MODAL_STATE", {
        title,
        isOpen: true,
        message,
        item,
        callback,
      });
    },
    closeConfirmationModal({ commit }) {
      commit("SET_CONFIRMATION_MODAL_STATE", { isOpen: false });
    },
    // openSettingsModal({ commit }) {
    //   commit("SET_SETTINGS_MODAL_STATE", { isOpen: true });
    // },
    // closeSettingsModal({ commit }) {
    //   commit("SET_SETTINGS_MODAL_STATE", { isOpen: false });
    // },
  },
  getters: {
    orderInvoiceModal: (state) => state.orderInvoiceModal,
    confirmationModal: (state) => state.confirmationModal,
    // settingsModal: (state) => state.settingsModal,
  },
};
